import {Transaction} from '../model/shared/transaction/transaction';
import {BaseResponse} from './internal/baseresponse';
export class TransactionGetResult extends BaseResponse {
  data: Transaction;
}



// WEBPACK FOOTER //
// ./src/app/response/transactiongetresult.ts